import { render, staticRenderFns } from "./PdfUpload.vue?vue&type=template&id=4b884feb&scoped=true"
import script from "./PdfUpload.vue?vue&type=script&lang=ts"
export * from "./PdfUpload.vue?vue&type=script&lang=ts"
import style0 from "./PdfUpload.vue?vue&type=style&index=0&id=4b884feb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b884feb",
  null
  
)

export default component.exports